import { Icons } from '@ui-core/icons/icons';
import Recursos from '../enums/recursos.enum';
import Titulos from '../enums/titulos.enum';
import { UserType } from '../enums/userType.enum';
import { ItemNav } from '../interfaces/menu.interface';
import { getFeatureFlag } from '../../../../utils/featureflag/getFeatureFlags';
import { Feature } from '../../../../utils/featureflag/featureFlags';

const BOTON_SEL = {
    id: Recursos.SEL,
    title: Titulos.SEL,
    to: import.meta.env.REACT_APP_SEL_SSO_URL,
    sso: {
        params: {
            access_token_param: 'at',
            refresh_token_param: 'rt',
            rut_param: 'cr'
        }
    }
};

interface ResourcesDataI {
    recursos: ResourceI[];
}

interface ResourceI {
    rec_codigo: string;
    rec_nombre: string;
    politica_clave: number;
}

const deprecatedMenuItems = [Titulos.CONFIGURACION];

const checkMenuSel = (currentResources: ResourcesDataI[]) => {
    let botonSel = false;
    let mantenedorSel = false;

    for (const resources of currentResources) {
        for (const resource of resources.recursos) {
            if (resource.rec_codigo === 'BOTON_SEL') botonSel = true;
            if (resource.rec_codigo === 'BOTON_MANTENEDOR_SEL')
                mantenedorSel = true;

            if (botonSel === true && mantenedorSel === true) break;
        }
    }

    return [botonSel, mantenedorSel];
};

export const checkMenuButtonOption = (itemNav: ItemNav[]): ItemNav[] => {
    try {
        let newItemNav = itemNav;
        const enterpriseRut = localStorage.getItem('rutEnterprise');
        const resourcesFull = JSON.parse(
            localStorage.getItem('dataRecursos') as string
        );
        const currentResources = resourcesFull.data.data.find(
            (item: { entidad: string | null }) =>
                item.entidad?.toUpperCase() === enterpriseRut?.toUpperCase()
        ).rolRecursos;
        const [botonSel, mantenedorSel] = checkMenuSel(currentResources);

        if (botonSel && !mantenedorSel) {
            newItemNav = itemNav.map((item) =>
                item.title === 'SEL' ? BOTON_SEL : item
            );
        }

        return newItemNav;
    } catch {
        return itemNav;
    }
};

export const checkSideMenuV2 = (sideMenuArr: ItemNav[]): ItemNav[] => {
	const deprecatedMenuItems = [Titulos.CONFIGURACION, Titulos.SOPORTE_DE_USUARIOS];
    function filterDeprecated(arr: string[], item: string | undefined) {
        if (item === undefined) return item;
        return !arr.includes(item);
    }
	if(getFeatureFlag(Feature.NavMenuV2)){
		return sideMenuArr.filter((item) =>
			filterDeprecated(deprecatedMenuItems, item.title),
		);
	}
	return sideMenuArr;
};

export const firstNavSectionsEMP: ItemNav[] = [
    {
        id: Recursos.INICIO_TRABAJADOR, // Pueden acceder todos los roles de ACHS virtual
        title: Titulos.INICIO_TRABAJADOR,
        to: 'inicio',
        iconName: Icons.HomeStart
    },
    {
        id: Recursos.MIS_SINIESTROS, // Pueden acceder todos los roles de ACHS virtual
        title: Titulos.MIS_SINIESTROS,
        to: `${import.meta.env.REACT_APP_HOST_BASE}/inicio/siniestros`,
        iconName: Icons.AccountInjuryOutline,
        externalLink: true,
        user_type: UserType.EMPLEADO
    },
    {
        id: Recursos.CAPACITACIONES_ELEARNING, // Pueden acceder todos los roles de ACHS virtual
        title: Titulos.CAPACITACIONES_ELEARNING,
        to: import.meta.env.REACT_APP_CAPACITACIONES_ELEARNING_SSO_URL,
        iconName: Icons.SchoolOutline,
        sso: {
            params: {
                access_token_param: '',
                rut_param: 'rut'
            }
        },
        user_type: UserType.EMPLEADO
    },
    {
        id: Recursos.CITAS_MEDICAS, // Pueden acceder todos los roles de ACHS virtual
        title: Titulos.CITAS_MEDICAS,
        to: `${import.meta.env.REACT_APP_HOST_BASE}/inicio/mis-citas-medicas`,
        iconName: Icons.MedicalCross,
        externalLink: true,
        user_type: UserType.EMPLEADO
    },
    {
        id: Recursos.RESULTADOS_EXAMENES_SALUD, // Pueden acceder todos los roles de ACHS virtual
        title: Titulos.RESULTADOS_EXAMENES_SALUD,
        to: `${import.meta.env.REACT_APP_HOST_BASE}/vigilancia/resultados`,
        iconName: Icons.ClipboardSearchOutline,
        externalLink: true,
        user_type: UserType.EMPLEADO
    },
    {
        id: Recursos.ESTADOS_DE_PAGOS, // Como usuario de ACHS Virtual
        title: Titulos.ESTADOS_DE_PAGOS,
        to: `${import.meta.env.REACT_APP_HOST_BASE}/estadopagos/subsidios`,
        iconName: Icons.StackedBillsOutline,
        externalLink: true,
        user_type: UserType.EMPLEADO
    },
    {
        id: Recursos.MUNDO_ACHS_TRABAJADOR, // Pueden acceder solo usuarios afiliados a la ACHS
        title: Titulos.MUNDO_ACHS_TRABAJADOR,
        to: import.meta.env.REACT_APP_MUNDO_ACHS_TRABAJADOR_RED_URL,
        externalLink: true,
        newTab: true,
        iconName: Icons.Earth,
        user_type: UserType.EMPLEADO
    }
];

const secondNavSection = {
    title: Titulos.CONFIGURACION,
    iconName: Icons.AccountCogOutline,
    items: [
        {
            id: Recursos.MI_PERFIL,
            title: Titulos.MI_PERFIL,
            to: 'inicio/mi-perfil'
        },
        {
            id: Recursos.EMPRESAS_VINCULADAS,
            title: Titulos.EMPRESAS_VINCULADAS,
            to: 'inicio/empresas-vinculadas'
        }
    ]
};

export const secondNavSectionsEMP: ItemNav[] = [
    secondNavSection,
    {
        title: Titulos.CENTRO_AYUDA,
        iconName: Icons.Headset,
        items: [
            {
                id: Recursos.TOUR_GUIADO,
                title: Titulos.TOUR_GUIADO,
                to: ''
            },
            {
                id: Recursos.MATERIAL_SOPORTE,
                title: Titulos.MATERIAL_SOPORTE,
                to: import.meta.env.REACT_APP_MATERIAL_SOPORTE_RED_URL,
                externalLink: true,
                newTab: true
            },
            {
                id: Recursos.NECESITAS_AYUDA,
                title: Titulos.NECESITAS_AYUDA,
                to: ''
            }
        ]
    },
    {
        id: Recursos.SOPORTE_DE_USUARIOS,
        title: Titulos.SOPORTE_DE_USUARIOS,
        to: `${import.meta.env.REACT_APP_HOST_BASE}/admin/soporte-usuarios`,
        iconName: Icons.AiOutlineTool,
        externalLink: true
    }
];

export const firstNavSectionsENT: ItemNav[] = [
    {
        id: Recursos.INICIO,
        title: Titulos.INICIO_EMPRESA,
        to: 'inicio/empresa',
        externalLink: false,
        iconName: Icons.HomeStart
    },
    {
        title: Titulos.EMPRESA_GESTION_SEGURO, // Como usuario con un rol distinto a "Sin permiso empresa"
        user_type: UserType.EMPRESA,
        items: [
            {
                id: Recursos.DATOS_EMPRESA, // Como usuario con rol Administrador, Coadministrador, Vista siniestros, Independiente (Afiliado ACHS), Trabajador ACHS, Contact Center, Superadmin, Administrador SEL, Soporte SEL
                title: Titulos.DATOS_EMPRESA,
                to: `${
                    import.meta.env.REACT_APP_HOST_BASE
                }/admin/datos-empresa`,
                iconName: Icons.BadgeAccountHorizontal,
                externalLink: true
            },
            {
                id: Recursos.COTIZACIONES, // Como usuario de ACHS Virtual con los roles administrador, coadministrador, independiente, trabajador ACHS (autoasignado), superadmin (autoasignado) y contact center (autoasignado)
                title: Titulos.COTIZACIONES,
                to: 'cotizaciones',
                iconName: Icons.CurrencyUsd,
                sso: {
                    isIFrame: true
                }
            },
            {
                id: Recursos.CERTIFICADOS_EMPRESA,
                title: Titulos.CERTIFICADOS_EMPRESA, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Servicio Evaluación Laboral, Trabajador ACHS autoasignado), Contact Center (autoasignado), Superadmin (autoasignado), Administrador SEL o Soporte SEL
                to: `${
                    import.meta.env.REACT_APP_HOST_BASE
                }/admin/certificados-empresa`,
                iconName: Icons.CertificateOutline,
                externalLink: true
            },
            {
                id: Recursos.DECRETO_SUPREMO_67, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.DECRETO_SUPREMO_67,
                to: getFeatureFlag(Feature.DS67) ? 'admin/ds67' : import.meta.env.REACT_APP_DECRETO_SUPREMO_67_SSO_URL, // token={}&rut={}
                iconName: Icons.FileOutline,
                sso: getFeatureFlag(Feature.DS67) ? undefined : {
                    params: {
                        access_token_param: 'token',
                        rut_param: 'rut'
                    },
					isAV2SSO: true
                }
            },
            {
                id: Recursos.DEVOLUCIONES, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.DEVOLUCIONES,
                to: import.meta.env.REACT_APP_DEVOLUCIONES_SSO_URL, // token={}&rut={}
                iconName: Icons.ClipboardArrowLeft,
                sso: {
                    params: {
                        access_token_param: 'token',
                        rut_param: 'rut'
                    },
					isAV2SSO: true
                }
            },
            {
                id: Recursos.MUNDO_ACHS_EMPRESA, // Usuario de ACHS virtual con vista empresa
                title: Titulos.MUNDO_ACHS_EMPRESA,
                to: import.meta.env.REACT_APP_MUNDO_ACHS_EMPRESA_RED_URL,
                iconName: Icons.GiftOutline,
                externalLink: true,
                newTab: true
            }
        ]
    },
    {
        title: Titulos.ADMIN_USUARIOS_TRABAJADORES,
        user_type: UserType.EMPRESA,
        items: [
            {
                id: Recursos.GESTION_USUARIOS, // Como usuario de ACHS Virtual
                title: Titulos.GESTION_USUARIOS,
                to: `${
                    import.meta.env.REACT_APP_HOST_BASE
                }/admin/gestion-usuario-general`,
                iconName: Icons.AccountCogOutline,
                externalLink: true
            },
            {
                id: Recursos.GESTION_CURSOS_ELEARNING, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.GESTION_CURSOS_ELEARNING,
                to: import.meta.env.REACT_APP_GESTION_CURSOS_ELEARNING_SSO_URL,
                iconName: Icons.SchoolOutline,
                sso: {
                    params: {
                        access_token_param: ''
                    }
                }
            }
        ]
    },
    {
        title: Titulos.GESTION_PREVENTIVA,
        user_type: UserType.EMPRESA,
        items: [
            {
                id: Recursos.ACHS_GESTION, // Como usuario de ACHS Virtual
                title: Titulos.ACHS_GESTION,
                to: import.meta.env.REACT_APP_ACHS_GESTION_RED_URL,
                iconName: Icons.CogBox,
                externalLink: true,
                newTab: true
            },
            {
                id: Recursos.AGENDAMIENTO_EXPERTO, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.AGENDAMIENTO_EXPERTO,
                to: import.meta.env.REACT_APP_AGENDAMIENTO_EXPERTO_SSO_URL,
                iconName: Icons.CalendarBank,
                sso: {
                    params: {
                        access_token_param: 'at',
                        rut_param: 'rut'
                    }
                }
            },
            {
                id: Recursos.LESIONES_GRAVES_FATALES, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.LESIONES_GRAVES_FATALES,
                to: import.meta.env.REACT_APP_LESIONES_GRAVES_FATALES_SSO_URL, // No está claro cuales parámetros se mandan en sso
                iconName: Icons.BriefcasePlus,
                sso: {
                    params: {
                        access_token_param: 'token'
                    }
                }
            },
            {
                id: Recursos.PLAN_MOVILIDAD, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Plan de Movilidad, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.PLAN_MOVILIDAD,
                to: 'plan-movilidad',
                iconName: Icons.VectorPolyline,
                sso: {
                    isIFrame: true
                }
            },
            {
                id: Recursos.PLATAFORMA_PSICOSOCIAL, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.PLATAFORMA_PSICOSOCIAL,
                to: import.meta.env.REACT_APP_PLATAFORMA_PSICOSOCIAL_SSO_URL, // token={}&rut={}
                iconName: Icons.AccountCogOutline,
                sso: {
                    params: {
                        access_token_param: 'token',
                        rut_param: 'rut'
                    },
					isAV2SSO: true
                }
            },
            {
                id: Recursos.AUTOEVALUACION_LEGAL, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.AUTOEVALUACION_LEGAL,
                to: import.meta.env.REACT_APP_AUTOEVALUACION_LEGAL_SSO_URL,
                iconName: Icons.ScaleBalance,
                externalLink: true,
                newTab: false
            },
            {
                id: Recursos.TMERT,
                title: Titulos.TMERT,
                to: import.meta.env.REACT_APP_TMERT_RED_URL,
                iconName: Icons.AlphaTBox,
                externalLink: true,
                newTab: true
            },
            {
                id: Recursos.SAC,
                title: Titulos.SAC,
                to: import.meta.env.REACT_APP_SAC_RED_URL,
                iconName: Icons.AlphaSBox,
                externalLink: true,
                newTab: true
            }
        ]
    },
    {
        title: Titulos.ACCIDENTES_ENFERMEDADES,
        user_type: UserType.EMPRESA,
        items: [
            {
				id: Recursos.SINIESTROS_EMPRESA, // como usuario de ACHS Virtual con rol Administrador, Coadministrador, Vista Siniestros, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado), Administrador SEL, Soporte SEL
				iconName: Icons.AccountInjuryOutline,
				externalLink: true,
				title: Titulos.SINIESTROS_EMPRESA,
				to: `${import.meta.env.REACT_APP_HOST_BASE}/admin/siniestros-empresa`,
				user_type: UserType.EMPRESA,
			},
            {
                id: Recursos.DENUNCIAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.DENUNCIAS,
                to: import.meta.env.REACT_APP_DENUNCIAS_SSO_URL, // token={}&rut={}
                iconName: Icons.AlarmLight,
                externalLink: false,
                sso: {
                    params: {
                        access_token_param: 'token',
                        rut_param: 'rut'
                    },
					isAV2SSO: true
                }
            },
            {
                id: Recursos.ESTADISTICAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.ESTADISTICAS,
                to: import.meta.env.REACT_APP_ESTADISTICAS_SSO_URL,
                iconName: Icons.ChartBox,
                externalLink: false,
                sso: {
                    params: {
                        access_token_param: 'token',
                        rut_param: 'rut'
                    },
					isAV2SSO: true
                }
            },
            {
                id: Recursos.PRESTACIONES_ECONOMICAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
                title: Titulos.PRESTACIONES_ECONOMICAS,
                to: import.meta.env.REACT_APP_PRESTACIONES_ECONOMICAS_SSO_URL,
                iconName: Icons.CashCheck,
                sso: {
                    params: {
                        access_token_param: 'token',
                        rut_param: 'rut'
                    },
					isAV2SSO: true
                }
            },
            {
				id: Recursos.PRESTACIONES_ECONOMICAS, // como usuario de ACHS Virtual con rol Administrador, Coadministrador, Vista Siniestros, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado), Administrador SEL, Soporte SEL
				iconName: Icons.CashCheck,
				externalLink: true,
				title: Titulos.PRESTACIONES_ECONOMICAS,
				to: `${import.meta.env.REACT_APP_HOST_BASE}/admin/prestaciones-economicas`,
				user_type: UserType.EMPRESA,
			},
            {
                id: Recursos.COVID_19, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Vista Siniestros, Plan de Movilidad, Servicio de Evaluación Laboral, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado), Administrador SEL, Soporte SEL
                title: Titulos.COVID_19,
                to: 'panel-covid-19',
                iconName: Icons.VirusOutline,
                sso: {
                    isIFrame: true
                }
            }
        ]
    },
    {
        title: Titulos.SEL,
        user_type: UserType.EMPRESA,
        items: [
            BOTON_SEL,
            {
                id: Recursos.MANTENEDOR_SEL,
                title: Titulos.MANTENEDOR_SEL,
                to: `${import.meta.env.REACT_APP_HOST_BASE}/sel/roles`,
                externalLink: true
            }
        ]
    }
];

export const secondNavSectionsENT: ItemNav[] = secondNavSectionsEMP;

export const MIS_SINIESTROS_ITEM = firstNavSectionsEMP.find(
    (i) => i.id === Recursos.MIS_SINIESTROS
);
export const CAPACITACIONES_ITEM = firstNavSectionsEMP.find(
    (i) => i.id === Recursos.CAPACITACIONES_ELEARNING
);

export const ESTADISTICAS_ITEM = {
    id: Recursos.ESTADISTICAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
    title: Titulos.ESTADISTICAS,
    to: import.meta.env.REACT_APP_ESTADISTICAS_SSO_URL,
    iconName: Icons.ChartBox,
    externalLink: false,
    sso: {
        params: {
            access_token_param: 'token',
            rut_param: 'rut'
        },
        isAV2SSO: true
    }
} satisfies ItemNav;
export const DENUNCIAS_ITEM = {
    id: Recursos.DENUNCIAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
    title: Titulos.DENUNCIAS,
    to: import.meta.env.REACT_APP_DENUNCIAS_SSO_URL, // token={}&rut={}
    iconName: Icons.AlarmLight,
    externalLink: false,
    sso: {
        params: {
            access_token_param: 'token',
            rut_param: 'rut'
        },
        isAV2SSO: true
    }
} satisfies ItemNav;
export const PRESTACIONES_ITEM = {
    id: Recursos.PRESTACIONES_ECONOMICAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
    title: Titulos.PRESTACIONES_ECONOMICAS,
    to: import.meta.env.REACT_APP_PRESTACIONES_ECONOMICAS_SSO_URL,
    iconName: Icons.CashCheck,
    sso: {
        params: {
            access_token_param: 'token',
            rut_param: 'rut'
        },
        isAV2SSO: true
    }
} satisfies ItemNav;

export const CERTIFICACIONES_ITEM = {
    id: Recursos.CERTIFICADOS_EMPRESA, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
    title: Titulos.CERTIFICADOS_EMPRESA,
    to: import.meta.env.REACT_APP_CERTIFICADOS_EMPRESA_SSO_URL,
    iconName: Icons.CashCheck,
    sso: {
        params: {
            access_token_param: 'token',
            rut_param: 'rut'
        },
        isAV2SSO: true
    }
} satisfies ItemNav;

export const SINIESTROS_EMPRESA_ITEM = {
    id: Recursos.SINIESTROS_EMPRESA, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Vista Siniestros, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado), Administrador SEL, Soporte SEL
    title: Titulos.SINIESTROS_EMPRESA,
    to: 'siniestros-empresa',
    iconName: Icons.AccountInjuryOutline,
    sso: {
        isIFrame: true
    }
} satisfies ItemNav;

export const DENUNCIAS_ESTAT = {
    id: Recursos.DENUNCIAS, // Como usuario de ACHS Virtual con rol Administrador, Coadministrador, Trabajador ACHS (autoasignado), Contact Center (autoasignado), Superadmin (autoasignado)
    title: Titulos.DENUNCIAS,
    to: import.meta.env.REACT_APP_DENUNCIAS_SSO_URL, // token={}&rut={}
    iconName: Icons.AlarmLight,
    externalLink: false,
    sso: {
        params: {
            access_token_param: 'token',
            rut_param: 'rut'
        },
        isAV2SSO: true
    }
} satisfies ItemNav;
